import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Badge } from "../../components/ui/badge";
import { Checkbox } from "../../components/ui/checkbox";
import {
  SHIPMENT_RULE_CHECKLIST,
  SHIPMENT_RULES,
  formatShipmentCurrency,
  parseShipmentNumber,
} from "./shipmentRules";

const ShipmentRulesReview = ({ shipmentValue, acknowledged, onAcknowledgedChange, isMobile = false }) => {
  const safeValue = parseShipmentNumber(shipmentValue);
  const threshold = SHIPMENT_RULES.freeInsuredLabelThreshold;
  const remaining = Math.max(threshold - safeValue, 0);
  const progress = Math.min((safeValue / threshold) * 100, 100);
  const eligible = safeValue >= threshold;

  return (
    <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 12 }}>
      <div
        style={{
          border: "1px solid rgba(255,255,255,0.075)",
          borderRadius: 8,
          padding: isMobile ? 12 : 13,
          background: "rgba(255,255,255,0.018)",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
          <div>
            <div style={{ fontSize: 13, color: "#fff", fontWeight: 700 }}>Shipment value</div>
            <div style={{ fontSize: 12.5, color: "#c3c8cc", marginTop: 3 }}>
              {eligible ? "Eligible for free insured labels" : `${formatShipmentCurrency(remaining)} away from free insured labels`}
            </div>
          </div>
          <Badge
            variant={eligible ? "success" : "secondary"}
            style={{
              background: "rgba(255,255,255,0.04)",
              color: eligible ? "#7bd88f" : "#f2f4f5",
              border: eligible ? "1px solid rgba(76,175,80,0.28)" : "1px solid rgba(255,255,255,0.1)",
              fontFamily: "ui-monospace, SF Mono, Menlo, monospace",
            }}
          >
            {formatShipmentCurrency(safeValue)} / {formatShipmentCurrency(threshold)}
          </Badge>
        </div>
        <div style={{ height: 6, borderRadius: 999, background: "rgba(255,255,255,0.08)", overflow: "hidden", marginTop: 12 }}>
          <div
            style={{
              width: `${progress}%`,
              minWidth: safeValue > 0 ? 8 : 0,
              height: "100%",
              borderRadius: 999,
              background: eligible ? "#4caf50" : "#00ADB5",
              transition: "width 0.18s ease",
            }}
          />
        </div>
      </div>

      <div
        style={{
          border: `1px solid ${acknowledged ? "rgba(0,173,181,0.35)" : "rgba(255,255,255,0.08)"}`,
          borderRadius: 8,
          padding: isMobile ? 12 : 13,
          background: acknowledged ? "rgba(0,173,181,0.06)" : "rgba(255,255,255,0.02)",
        }}
      >
        <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
          <Checkbox
            checked={acknowledged}
            onChange={(event) => onAcknowledgedChange(event.target.checked)}
            size={18}
            style={{ marginTop: 1 }}
          />
          <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
            <div style={{ color: "#fff", fontSize: 13.5, fontWeight: 700 }}>I confirm this shipment follows RSC shipping rules</div>
            <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: "6px 14px" }}>
              {SHIPMENT_RULE_CHECKLIST.map((item) => (
                <span key={item} style={{ display: "flex", alignItems: "flex-start", gap: 6, color: "#c3c8cc", fontSize: 12, lineHeight: 1.4 }}>
                  <CheckCircle2 size={13} color="#00ADB5" style={{ marginTop: 2, flexShrink: 0 }} />
                  <span>{item.replace(/^I confirm |^I understand /, "")}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShipmentRulesReview;
